import React from 'react';
import { ClientConfig } from '../types/profile';
import { useLocalization } from '../engine/localization/context';
import { ShieldCheck } from 'lucide-react';

interface FooterProps {
  config: ClientConfig;
}

export const Footer: React.FC<FooterProps> = ({ config }) => {
  const { resolve } = useLocalization();

  const footerText = config.footerText ? resolve(config.footerText) : `© ${new Date().getFullYear()} ${resolve(config.identity.name)}`;
  const regionsText = config.regionsText ? resolve(config.regionsText) : null;

  return (
    <footer className="mt-8 pt-6 border-t border-white/10 text-center text-xs text-slate-400 space-y-2 pb-6">
      <p className="font-medium text-slate-300">{footerText}</p>
      {regionsText && <p className="text-[11px] text-slate-400">{regionsText}</p>}
      
      {/* Reusable Subtle Platform Attribution */}
      <div className="pt-2 flex flex-col items-center justify-center gap-1 text-[11px]">
        {/*
          Smart Digital Profile Pre-SaaS Product Destination:
          All profiles link to the Smart Digital Profile product landing page.
        */}
        <a
          href={config.branding.poweredByUrl || '/smart-profile'}
          className="inline-flex items-center gap-1.5 text-slate-400 hover:text-sky-400 transition-all duration-200 cursor-pointer select-none hover:scale-105 active:scale-95 group focus:outline-none focus:ring-2 focus:ring-sky-400/50 rounded-lg px-2 py-1"
          title={resolve({
            ar: 'الملف الرقمي الذكي من JetOwn',
            en: 'Smart Digital Profile by JetOwn',
          })}
        >
          <span className="text-slate-500 text-[10px] group-hover:text-slate-400 transition-colors">Powered by</span>
          <span className="font-bold tracking-wide text-sky-400/90 group-hover:text-sky-300 text-xs transition-colors">JetOwn</span>
          <ShieldCheck className="w-3.5 h-3.5 text-sky-400/70 group-hover:text-sky-400 inline transition-colors" />
        </a>
      </div>
    </footer>
  );
};

